import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AdPlaceholder from '../AdPlaceholder';
import { LetterHiveBrandIcon, WordRungsBrandIcon } from '../icons/BrandGameIcons';
import { COZY_HUB_GAMES } from '../../data/cozyHubGames';
import './Sidebar.css';

function SidebarGameIcon({ game, active }) {
  const tone = active ? 'onAccent' : 'brand';
  if (game.iconId === 'letter-hive') {
    return <LetterHiveBrandIcon title={game.name} tone={tone} />;
  }
  if (game.iconId === 'word-rungs') {
    return <WordRungsBrandIcon title={game.name} tone={tone} />;
  }
  return <>{game.icon}</>;
}

const HELP_LINKS = [
  { path: '/how-to-play', name: 'How to play', icon: '📖', desc: 'Rules and tips' },
  { path: '/faq', name: 'FAQ', icon: '❓', desc: 'Common questions' },
  { path: '/about', name: 'About', icon: '💬', desc: 'What is Letter Quest' },
  { path: '/feedback', name: 'Feedback', icon: '✉️', desc: 'Report bugs and ideas' },
  { path: '/apps', name: 'Get the app', icon: '📱', desc: 'App Store & Google Play' },
  { path: '/leaderboard', name: 'Leaderboard', icon: '🏆', desc: 'Top scores and streaks' },
];

export function Sidebar() {
  const location = useLocation();
  const { user, profile } = useAuth();

  return (
    <aside className="sidebar">
      {user && profile && (
        <div className="sidebar-streak">
          <span className="sidebar-streak-value">🔥 {profile.globalStreak ?? 0}</span>
          <span className="sidebar-streak-label">Day Streak</span>
        </div>
      )}
      <nav className="sidebar-nav">
        {COZY_HUB_GAMES.map((game) => {
          const active = location.pathname === game.path;
          return (
            <Link
              key={game.path}
              to={game.path}
              className={`sidebar-link ${active ? 'active' : ''}`}
            >
              <span className="sidebar-link-icon">
                <SidebarGameIcon game={game} active={active} />
              </span>
              <span className="sidebar-link-name">{game.name}</span>
            </Link>
          );
        })}
        <div className="sidebar-nav-divider" aria-hidden="true" />
        {HELP_LINKS.map((link) => {
          const active = location.pathname === link.path;
          return (
            <Link
              key={link.path}
              to={link.path}
              className={`sidebar-link ${active ? 'active' : ''}`}
            >
              <span className="sidebar-link-icon">{link.icon}</span>
              <span className="sidebar-link-name">{link.name}</span>
            </Link>
          );
        })}
      </nav>
      <div className="sidebar-ad">
        <AdPlaceholder variant="sidebar" />
      </div>
    </aside>
  );
}
